import { icInfo } from '@vivareal/lina-icons'

import ozIconRemoveFilter from '@/pages/results/components/filters/oz-icon-remove-filter'

export default {
  name: 'oz-toggle',

  props: {
    isTooltipActive: { type: Boolean, default: false },
    tooltipText: { type: String },
    initialValue: { type: Boolean },
    title: { type: String, required: true },
    isPill: { type: Boolean, default: false },
    disabled: { type: Boolean },
  },

  data () {
    return {
      toggleValue: false,
    }
  },

  created () {
    this.toggleValue = this.initialValue
  },

  watch: {
    initialValue () {
      this.toggleValue = this.initialValue
    },
  },

  computed: {
    icon () {
      return icInfo
    },
  },

  methods: {
    onToggleUpdate () {
      this.toggleValue = !this.toggleValue

      this.updateFilter()
    },

    updateFilter () {
      this.$emit('filters:update', this.toggleValue)
    },

    removeFilter () {
      this.toggleValue = false
      this.updateFilter()
    },
  },

  components: {
    ozIconRemoveFilter,
  },
}
